/**
 * Force Publish Content UseCase
 *
 * Force-publishes an existing draft or scheduled content item.
 * Mirrors Flutter MediasRepository.publishContent →
 * CloudFunctionsService.forcePublishContent
 * (lib/data/repository/medias_repository.dart:365).
 *
 * Note: this is distinct from `publishContentUseCase` under `publish/`,
 * which uploads a brand-new media item.
 */

import { MediaService } from '@/domain/services/media/mediaService';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class ForcePublishContentUseCase {
  private mediaService: MediaService;

  constructor(mediaService?: MediaService) {
    this.mediaService = mediaService || new MediaService();
  }

  async execute(contentId: string): Promise<boolean> {
    try {
      return await this.mediaService.publishContent(contentId);
    } catch (error) {
      appLogger.error('Error force-publishing content', 'ForcePublishContentUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const forcePublishContentUseCase = new ForcePublishContentUseCase();
